import { Directive, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as Pikaday from 'pikaday';
import { Utils } from '../classes';

@Directive({
  selector: '[geoPikaday]'
})
export class PikadayDirective implements OnInit, OnChanges {
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() defaultDate: string;

  @Output() dateSelect = new EventEmitter();

  picker: Pikaday;

  i18n: Pikaday.PikadayI18nConfig = {
    previousMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
  };

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.picker = new Pikaday({
      field: this.el.nativeElement,
      i18n: this.i18n,
      firstDay: 1,
      onSelect: date => {
        this.dateSelect.emit(Utils.getDateString(date));
      }
    });
  }

  // таймаут на случай, если Pikaday еще не успел проинициализироваться
  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      if (changes.minDate && changes.minDate.currentValue) {
        this.picker.setMinDate(new Date(changes.minDate.currentValue));
      } else if (changes.maxDate && changes.maxDate.currentValue) {
        this.picker.setMaxDate(new Date(changes.maxDate.currentValue));
      } else if (changes.defaultDate && changes.defaultDate.currentValue) {
        this.picker.setDate(new Date(changes.defaultDate.currentValue));
      }
    });
  }
}
